"use client";

// ── Тонкая полоса загрузки вверху экрана (№29 каталога движения) ─────────────
// ЗАЧЕМ. Между «нажал на вкладку» и «увидел новые данные» проходит секунда-две,
// и всё это время экран показывает СТАРОЕ содержимое. Человек не понимает,
// попал он по кнопке или промахнулся, и жмёт второй раз. Полоса отвечает на
// этот вопрос, не занимая места и не перерисовывая содержимое.
//
// Считаем запросы в полёте в apiFetchRaw (единственная точка, через которую
// ходит весь портал), поэтому отдельно размечать экраны не нужно.
//
// ПОРОГ. Полоса появляется, только если запрос летит дольше 400 мс. Иначе
// каждый быстрый ответ и каждый фоновый опрос статуса (useStatusPoll, раз в
// 5 с) давали бы вспышку вверху экрана — ровно то мигание, от которого
// защищает лестница ожидания (см. useWaitStage в components/ui/states.tsx).

const SHOW_AFTER_MS = 400;

type Listener = (visible: boolean) => void;

let inFlight = 0;
let visible = false;
let timer: ReturnType<typeof setTimeout> | null = null;
const listeners = new Set<Listener>();

function emit() {
  listeners.forEach((fn) => fn(visible));
}

function show() {
  if (visible) return;
  visible = true;
  emit();
}

function hide() {
  if (timer) { clearTimeout(timer); timer = null; }
  if (!visible) return;
  visible = false;
  emit();
}

/** Начало ожидания. Возвращает функцию завершения — её зовут в finally. */
export function beginTopProgress(): () => void {
  inFlight += 1;
  if (inFlight === 1 && !timer && !visible) {
    timer = setTimeout(() => { timer = null; show(); }, SHOW_AFTER_MS);
  }
  let ended = false;
  return () => {
    if (ended) return; // повторный вызов не должен уводить счётчик в минус
    ended = true;
    inFlight = Math.max(0, inFlight - 1);
    if (inFlight === 0) hide();
  };
}

export function subscribeTopProgress(fn: Listener): () => void {
  listeners.add(fn);
  fn(visible);
  return () => { listeners.delete(fn); };
}
